import React from "react";
import PropTypes from "prop-types";
import {
  Wrapper,
  Inner,
  Text,
  Check,
} from "./styles/post-action-message-styles";
import check from "./img/check.gif";

const PostActionMessage = (props) => {
  const { text } = props;

  return (
    <Wrapper>
      <Inner>
        <Check src={check} alt="Thank You Check" className="animated fadeIn" />
        <Text className="animated delay fadeInDown">{text}</Text>
      </Inner>
    </Wrapper>
  );
};

PostActionMessage.propTypes = {
  text: PropTypes.string.isRequired,
};

export default PostActionMessage;
